var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{class:[
    'rounded-full py-1 px-3 text-xs font-medium',
    { 'bg-danger-50 text-danger-600': _vm.dueDatePassed },
    { 'bg-success-100 text-success-600': !_vm.dueDatePassed } ]},[_vm._v(" "+_vm._s(_vm.$t("components.operations.preOpening.due"))+" "+_vm._s(_vm.formattedDate)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }